import { v4 as uuidv4 } from 'uuid';
import { addScheduleAPI } from './api';
import { getStore } from '../../factory';

export async function addSchedule(subscription, schedule) {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.env.startLoadCounter({ target: 'appProgress' });
    this.loadingList[schedule.scheduleId] = true;
    this.observed.loadingList = uuidv4();

    const res = await addScheduleAPI({
        body: { calendarIds: [schedule.scheduleId] },
        store: this,
        token: session.token,
        traceId,
        subscriptionId: subscription.id,
    });

    this.env.stopLoadCounter();
    delete this.loadingList[schedule.scheduleId];
    this.observed.loadingList = uuidv4();

    if (res?.error) return;

    const subscriptionsStore = getStore('subscriptions');

    // Refresh from backend — ensures list reflects actual server state
    await subscriptionsStore.refreshSubscriptions();

    this.addList.push({ schedule, subscription });
    this.observed.addList = uuidv4();
}

export function removeItemFromAddlist() {
    this.addList.pop();
}
